/**
 * NiV "כלים" tab — admin utilities grouped under one tab with a segmented
 * sub-nav (URL: /dashboard/niv/tools/:sub).
 */

import {
  BellRinging,
  CalendarCheck,
  ChatCircleDots,
  CreditCard,
  ForkKnife,
  Info,
  Megaphone,
  WhatsappLogo,
} from "@phosphor-icons/react";
import { useGetSystemNotificationsQuery } from "../../../../store/services/nivApi";
import NivPushTool from "./NivPushTool";
import NivSystemMessagesTool from "./NivSystemMessagesTool";
import NivSystemUpdatesTool from "./NivSystemUpdatesTool";
import NivMonthlyReportTool from "./NivMonthlyReportTool";
import NivInfoTool from "./NivInfoTool";
import NivFoodRequestsTool from "./NivFoodRequestsTool";
import NivWhatsAppTool from "./NivWhatsAppTool";
import NivGrowTool from "./NivGrowTool";
import "./NivToolsTab.css";

export const TOOL_SECTIONS = [
  { id: "push", label: "שליחת Push", icon: Megaphone },
  { id: "messages", label: "הודעות מערכת", icon: ChatCircleDots },
  { id: "updates", label: "עדכוני מערכת", icon: BellRinging },
  { id: "report", label: "דוח חודשי", icon: CalendarCheck },
  { id: "foods", label: "בקשות מזון", icon: ForkKnife },
  { id: "whatsapp", label: "WhatsApp", icon: WhatsappLogo },
  { id: "grow", label: "Grow", icon: CreditCard },
  { id: "info", label: "מידע ותזכורות", icon: Info },
];
export const TOOL_SECTION_IDS = new Set(TOOL_SECTIONS.map((s) => s.id));
export const DEFAULT_TOOL_SECTION = "push";

function NivToolsTab({ isAuthorized, section, onSectionChange }) {
  const active = TOOL_SECTION_IDS.has(section) ? section : DEFAULT_TOOL_SECTION;
  const { data: systemNotifications = [] } = useGetSystemNotificationsQuery(undefined, {
    skip: !isAuthorized,
  });

  return (
    <div className="nivtools">
      <nav className="nivtools-subnav" aria-label="כלים">
        {TOOL_SECTIONS.map((s) => {
          const isActive = s.id === active;
          const badge = s.id === "updates" ? systemNotifications.length : 0;
          return (
            <button
              key={s.id}
              type="button"
              className={`nivtools-subnav-item ${isActive ? "active" : ""}`}
              onClick={() => onSectionChange(s.id)}
              aria-current={isActive ? "page" : undefined}
            >
              <s.icon size={16} weight={isActive ? "fill" : "regular"} />
              <span>{s.label}</span>
              {badge > 0 && <span className="nivtools-subnav-badge">{badge}</span>}
            </button>
          );
        })}
      </nav>

      <div className="nivtools-body" key={active}>
        {active === "push" && <NivPushTool isAuthorized={isAuthorized} />}
        {active === "messages" && <NivSystemMessagesTool isAuthorized={isAuthorized} />}
        {active === "updates" && <NivSystemUpdatesTool isAuthorized={isAuthorized} />}
        {active === "report" && <NivMonthlyReportTool isAuthorized={isAuthorized} />}
        {active === "foods" && <NivFoodRequestsTool isAuthorized={isAuthorized} />}
        {active === "whatsapp" && <NivWhatsAppTool isAuthorized={isAuthorized} />}
        {active === "grow" && <NivGrowTool isAuthorized={isAuthorized} />}
        {active === "info" && <NivInfoTool />}
      </div>
    </div>
  );
}

export default NivToolsTab;
